import { ELocalStorageKeys } from "constants/enums";

import { localStorageUtil } from "./localStorageUtil";

export const enrichOptions = (options: Record<string, any>) => {
  try {
    const userDetails = localStorageUtil.getAny(ELocalStorageKeys.USER_DETAILS);
    const publisherId = localStorageUtil.getAny(ELocalStorageKeys.PUBLISHER_ID);
    
    const enrichedOptions: Record<string, any> = {
      ...options,
      ...(publisherId  && { company_id: publisherId }),
      ...(userDetails?.userId && { user_id: userDetails.userId }),
      ...(userDetails?.email  && { email: userDetails.email }),
    };

    return enrichedOptions;
  } catch (error) {
    console.error('Failed to enrich options:', error);
    return options;
  }
};

export const getUtmParams = (): Record<string, string> => {
  const params = new URLSearchParams(window.location.search);
  const utmData: Record<string, string> = {};
  const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  utmKeys.forEach((key) => {
    const value = params.get(key);
    if (value) {
      utmData[key] = value;
    }
  });

  if (Object.keys(utmData).length > 0) {
    return utmData;
  }

  return {};
};

export const getReferrerData = () => {
  const referrerData: Record<string, string> = {};
  
  if (document.referrer) {
    referrerData.referrer = document.referrer;
  }
  const params = new URLSearchParams(window.location.search);
  if (!document.referrer && params.get('from')) {
    referrerData.referrer = params.get('from') || '';
  }
  
  return referrerData;
};

export const getAttributionData = (): Record<string, string> => {
  return {
    ...getUtmParams(),
    ...getReferrerData()
  };
};